
let eventCardsArr = document.querySelectorAll(".event-item-card");
let eventTypeSelector = document.querySelector("#typeSelector");
let eventGmSelector = document.querySelector("#gmSelector");
let resetBtn = document.getElementById("reset");
let labelArr = [];
let gmArr = [];
let labelSelected = 'default';
let gmSelected = "default";

function getDataArrays(){
    eventCardsArr.forEach((el)=>{
        if ( el.getAttribute("data-label") && (!labelArr.includes(el.getAttribute("data-label")))){
            labelArr.push(el.getAttribute("data-label"));
        }
        if ( el.getAttribute("data-gm") && (!gmArr.includes(el.getAttribute("data-gm")))){
            gmArr.push(el.getAttribute("data-gm"));
        }
        
    })
}
function createTypeOptions(){
    labelArr.forEach(el=>{
        let optionEl = document.createElement("option");
        optionEl.value = el;
        optionEl.innerText = el;
        // console.log(optionEl, typeof(optionEl))
        eventTypeSelector.appendChild(optionEl);

    })
}
function createGmOptions(){
    gmArr.forEach(el=>{
        let optionEl = document.createElement("option");
        optionEl.value = el;
        optionEl.innerText = el;
        eventGmSelector.appendChild(optionEl);

    })
}
eventTypeSelector.addEventListener("change",(e)=>{
    labelSelected = e.target.value;
    eventCardsArr.forEach(el=>{
        if(
            labelSelected == 'default' && gmSelected == "default" ||
            labelSelected == 'default' && gmSelected == el.getAttribute("data-gm") ||
            labelSelected == el.getAttribute("data-label") && gmSelected == "default" ||
            labelSelected == el.getAttribute("data-label") && gmSelected == el.getAttribute("data-gm")
        ){
            el.style.display = "block";
        }else {
            el.style.display = "none"
        }
    })
    
    
})
eventGmSelector.addEventListener("change",(e)=>{
    gmSelected = e.target.value;
    eventCardsArr.forEach(el=>{
        if(
            gmSelected == 'default' && labelSelected == "default" ||
            gmSelected == 'default' && labelSelected == el.getAttribute("data-label") ||
            gmSelected == el.getAttribute("data-gm") && labelSelected == "default" ||
            gmSelected == el.getAttribute("data-gm") && labelSelected == el.getAttribute("data-label")
        ){
            el.style.display = "block";
        }else {
            el.style.display = "none"
        }
    })
    
    
})
resetBtn.addEventListener("click",()=>{
    eventTypeSelector.selectedIndex = "0"
    eventGmSelector.selectedIndex = "0"
    eventCardsArr.forEach(el=>{
        el.style.display = "block"
    })
})

getDataArrays();
createTypeOptions();
createGmOptions();